import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { OrganizationService } from '../../shared/services/organization.service';

@Injectable()
export class OrganizationResolver implements Resolve<any> {
    constructor( public organizationService: OrganizationService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.organizationService.getOrganization(route.params.id);
    }
}
